









































import { Component, mixins } from '@niknevis/vue-modules'
import AdminLayout from '@/modules/common/layout/components/admin/AdminLayout.vue'
import TesTable from '@/modules/common/tes-table/components/shared/TesTable.vue'
import { Prop, ProvideReactive } from 'vue-property-decorator'
import { QsPaginatableMixin } from '@/modules/shared/mixins/qs-paginatable.mixin'
import { QsSearchableMixin } from '@/modules/shared/mixins/qs-searchable.mixin'
import PaginationWithInput from '@/modules/shared/components/shared/pagination/PaginationWithInput.vue'
import FilterRow from '@/modules/common/filter/components/shared/layout/FilterRow.vue'
import { DatePresetTypes, Filter, FilterTypes } from '@/modules/common/filter/filter'
import collect from 'collect.js'
import AdminUserSearchFilter from '@/modules/user/components/admin/AdminUserSearchFilter.vue'
import { TicketCollectionTypeInAdmin } from '@/modules/ticket/models/ticket-collection.model'
import { getTicketColumnsInAdmin } from '@/modules/ticket/models/columns/ticket-table.column'
import AdminTicketTableRow from '@/modules/ticket/components/admin/table/AdminTicketTableRow.vue'
import { FilterService } from '@/modules/common/filter/services/filter.service'
import AdminCampaignSearchFilter from '@/modules/base-campaign/components/admin/AdminCampaignSearchFilter.vue'
import AdminDepartmentSearchFilter from '@/modules/department/components/admin/AdminDepartmentSearchFilter.vue'
import AdminCreateTicketButton from '@/modules/ticket/components/admin/AdminCreateTicketButton.vue'
import TableExportButton from '@/modules/common/table-export/components/TableExportButton.vue'
import { AdminTicketRoute } from '@/modules/ticket/routes/admin-ticket.route'
import PersonSearchFilter from '@/modules/common/person/components/ZoneSearchFilter.vue'

@Component({
  layout: AdminLayout,
  layoutProps: {
    page_header: 'لیست تیکت ها'
  },
  metaInfo: {
    title: 'لیست تیکت ها'
  },
  components: {
    TableExportButton,
    AdminCreateTicketButton,
    TesTable,
    FilterRow,
    PaginationWithInput
  }
})
export default class IndexPage extends mixins(QsPaginatableMixin, QsSearchableMixin) {
  constructor(
    private readonly filterService: FilterService,
    private readonly ticketRoute: AdminTicketRoute
  ) {
    super()
  }

  @ProvideReactive()
  @Prop() tickets: TicketCollectionTypeInAdmin
  private rowComponent = AdminTicketTableRow
  private columns = getTicketColumnsInAdmin()

  private filters = [
    new Filter({
      type: FilterTypes.ComboBox,
      title: 'وضعیت',
      key: 'statuses',
      holder: 'انتخاب کنید',
      default: this.tickets.default_filters.statuses,
      typeMode: false,
      items: collect(this.tickets.statuses)
        .map((item, index) => ({
          label: item,
          value: index
        })).toArray()
    }),
    new Filter({
      type: FilterTypes.Custom,
      key: 'user',
      title: 'کاربر',
      typeMode: false,
      component: AdminUserSearchFilter
    }),
    new Filter({
      component: AdminDepartmentSearchFilter,
      type: FilterTypes.Custom,
      key: 'department',
      title: 'دپارتمان',
      typeMode: false
    }),
    new Filter({
      component: PersonSearchFilter,
      type: FilterTypes.Custom,
      key: 'person',
      title: 'پنل',
      typeMode: false
    }),
    new Filter({
      component: AdminCampaignSearchFilter,
      type: FilterTypes.Custom,
      key: 'campaign',
      title: 'کمپین',
      typeMode: false
    }),
    new Filter({
      type: FilterTypes.DateRange,
      keys: {
        from: 'last_answer_date_from',
        to: 'last_answer_date_to'
      },
      title: 'تاریخ آخرین پاسخ',
      presets: [
        DatePresetTypes.today,
        DatePresetTypes.yesterday,
        DatePresetTypes.currentWeek,
        DatePresetTypes.currentMonth,
        DatePresetTypes.custom
      ]
    })
  ]

  protected get model(): any {
    return this.tickets
  }

  private updatePage(page: number) {
    this.updateTable({
      pagination: {
        ...this.pagination,
        page
      }
    })
  }
}
